import { Stack } from '@mui/material'
import { useFormikContext } from 'formik'
import { InputHTMLAttributes } from 'react'
import { Input } from '../../../styled'

export default function ValidatedTextInput<T extends InputHTMLAttributes<HTMLInputElement>>({name="", type="text", ...input_props}:T) {

  const {setFieldValue, setFieldTouched, values, errors, touched} = useFormikContext<any>()
  
  return (
      <Stack direction="column" spacing={1}>
        <Input 
          {...input_props}
          onChange={({target})=>{
            setFieldValue(name, target.value)
          }}
          onBlur={()=>setFieldTouched(name)}
          value={values[name]}
          type={type}
        />
        
        {(errors[name] && touched[name]) && 
          (
            <span className="text-left bg-error inline-block w-2 h-2 rounded-full"/>
          )
        }
      </Stack>
  )
}
